import { enforce, create, test, only } from "vest";

export default create((currentField, data = {}) => {
    only(currentField);
    test("cliente_id", "El campo Cliente es requerido", () => {
        enforce(data.cliente_id).isNotEmpty();
    });
    test("referencia", "El campo Referencia es requerido", () => {
        enforce(data.referencia).isNotEmpty();
    });

    test("direccion", "El campo Direccion es requerido", () => {
        enforce(data.direccion).isNotEmpty();
    });

    test(
        "sector_economico_id",
        "El campo Sector Económico es requerido",
        () => {
            enforce(data.sector_economico_id).isNotEmpty();
        },
    );
    test("distribuidor_id", "El campo Distribuidor es requerido", () => {
        enforce(data.distribuidor_id).isNotEmpty();
    });
    test(
        "contacto_comercial_nombre",
        "El campo Contacto Comercial Nombre es requerido",
        () => {
            enforce(data.contacto_comercial_nombre).isNotEmpty();
        },
    );

    test(
        "contacto_comercial_tel",
        "El campo Contacto Comercial Teléfono es requerido",
        () => {
            enforce(data.contacto_comercial_tel).isNotEmpty();
        },
    );

    test(
        "contacto_comercial_email",
        "El campo Contacto Comercial Email es requerido",
        () => {
            enforce(data.contacto_comercial_email).isNotEmpty();
        },
    );

    test(
        "contacto_logistico_nombre",
        "El campo Contacto Logístico Nombre es requerido",
        () => {
            enforce(data.contacto_logistico_nombre).isNotEmpty();
        },
    );

    test(
        "contacto_logistico_tel",
        "El campo Contacto Logístico Teléfono es requerido",
        () => {
            enforce(data.contacto_logistico_tel).isNotEmpty();
        },
    );

    test(
        "contacto_logistico_email",
        "El campo Contacto Logístico Email es requerido",
        () => {
            enforce(data.contacto_logistico_email).isNotEmpty();
        },
    );
});
